import React from 'react';
import classNames from 'classnames';
import i18n from 'src/utils/translate';
import styled from 'styled-components';
import { textLinkPrimary } from 'styles-js/mixins/typography';

const StyledLink = styled.a`
  ${textLinkPrimary};
  flex-shrink: 0;
`;

const Card = ({ children, title, className, seeAllLink, seeAllOnClick, seeAllText }) => {
  const cardClasses = classNames({
    'community__widget': true,
    [className]: !!className,
  });

  return (
    <div className={cardClasses}>
      {title && (
        <div className="community__widget__header">
          <h2>{title}</h2>
          {seeAllLink && (
            <StyledLink
              href={seeAllLink}
              onClick={e => {
                if (seeAllOnClick) {
                  seeAllOnClick(e);
                }
              }}
            >
              {seeAllText ? seeAllText : i18n.t('See all')}
              <span className="icon icon-right-open" />
            </StyledLink>
          )}
        </div>
      )}
      <div className="community__widget__body" >
        {children}
      </div>
    </div>
  );
};

Card.defaultProps = {
  seeAllText: null,
  title: null,
  className: null,
  seeAllLink: null,
  seeAllOnClick: null,
};

export default Card;
